(() => {
  const logic = {
    visit(previous, now, idleMs) {
      const current = previous && Number.isFinite(previous.startedAt) && Number.isFinite(previous.lastSeenAt) && previous.startedAt <= previous.lastSeenAt && previous.lastSeenAt <= now && now - previous.lastSeenAt < idleMs;
      return current ? {...previous, lastSeenAt: now} : {startedAt: now, lastSeenAt: now, shownAt: null};
    },
    due(visit, now, delayMs) {
      return Boolean(visit && visit.shownAt == null && now - visit.startedAt >= delayMs);
    },
    email(value) {
      const normalized = value.trim().toLowerCase();
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(normalized) && normalized.length <= 254;
    },
    result(state, hasError) {
      if (hasError || state === 'error') return 'error';
      return state === 'accepted' ? 'accepted' : 'unknown';
    }
  };
  window.CareizSignupLogic = Object.freeze(logic);
  if (customElements.get('careiz-signup')) return;
  customElements.define('careiz-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.email = this.form.querySelector('[name="contact[email]"]');
      this.shield = this.querySelector('[data-shield]');
      this.teaser = this.querySelector('[data-open]');
      this.verification = this.querySelector('[data-verification]');
      this.error = this.querySelector('[data-client-error]');
      this.submitButton = this.form.querySelector('[data-submit]');
      if(this.dataset.thanksMode==='popup'){
        // Shopify also persists the DOM form before submission; keep that copy native too.
        const returnInput=this.form.querySelector('[name="return_to"]');
        if(returnInput)returnInput.disabled=true;
        this.form.submit=()=>this.send();
      }
      this.submitLabel = this.submitButton.innerHTML;
      this.visitKey = 'careiz-popup-visit-v3:' + this.dataset.scope;
      this.completedKey = 'careiz-popup-completed-v3:' + this.dataset.scope;
      this.submittedKey = 'careiz-popup-pending-v4:' + this.dataset.scope;
      this.idleMs = Number(this.dataset.visitMinutes) * 60000;
      this.delayMs = Number(this.dataset.delay) * 1000;
      this.editor = this.dataset.editor === 'true';
      this.query = new URLSearchParams(location.search);
      const draft = this.dataset.draft === 'true';
      this.forced = draft && this.query.get('careiz_popup_preview') === '1';
      this.otherPreview = this.query.has('careiz_reward_preview') || this.query.has('careiz_coupon_preview');
      if (draft && this.query.get('careiz_popup_test') === '1') this.store('sessionStorage', 'careiz-popup-test:' + this.dataset.scope, '1');
      this.testing = draft && this.read('sessionStorage', 'careiz-popup-test:' + this.dataset.scope) === '1';
      if(this.testing){this.visitKey+=':test';this.completedKey+=':test';}
      this.active = this.dataset.active === 'true' || this.testing;
      this.complete = this.read('localStorage', this.completedKey) === '1';
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.close(), {signal:this.signal}));
      this.teaser.addEventListener('click', () => this.open(), {signal:this.signal});
      this.dialog.addEventListener('cancel', event => {event.preventDefault();this.close();}, {signal:this.signal});
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog || this.pending) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      }, {signal:this.signal});
      this.shield.addEventListener('click', () => {if(!this.pending)this.close();}, {signal:this.signal});
      document.addEventListener('keydown', event => {if(event.key==='Escape' && this.dialog.open && !this.dialog.matches(':modal'))this.close();}, {signal:this.signal});
      this.dialog.addEventListener('close', () => {if(!this.dialog.open)this.restore();}, {signal:this.signal});
      this.form.querySelectorAll('[data-validation]').forEach(input => {
        input.addEventListener('invalid', () => {
          input.setCustomValidity(input.dataset.validation);
          if(input===this.email)this.fail(input.dataset.validation,true,false);
        }, {signal:this.signal});
        ['input','change'].forEach(name=>input.addEventListener(name,()=>{input.setCustomValidity('');if(input===this.email)this.clearError();},{signal:this.signal}));
      });
      this.form.addEventListener('submit', event => this.submit(event), {signal:this.signal});
      document.addEventListener('shopify:section:select', event => {
        if(this.editor && event.detail.sectionId===this.dataset.section)this.open();
      }, {signal:this.signal});
      document.addEventListener('shopify:section:deselect', event => {
        if(this.editor && event.detail.sectionId===this.dataset.section && !this.pending)this.close();
      }, {signal:this.signal});
      window.addEventListener('storage', event => {
        if(event.key===this.completedKey){this.complete=event.newValue==='1';this.updateTeaser();}
        if(event.key===this.visitKey || event.key===this.completedKey)this.schedule();
      }, {signal:this.signal});
      document.addEventListener('visibilitychange',()=>{
        if(document.hidden){this.touch();clearTimeout(this.timer);}
        else{this.touch();this.schedule();}
      }, {signal:this.signal});
      window.addEventListener('pagehide',()=>this.touch(),{signal:this.signal});
      window.addEventListener('pageshow',event=>{if(event.persisted){this.touch();this.schedule();}},{signal:this.signal});
      document.addEventListener('careiz:reward-ready',()=>{
        if(!this.testing && document.querySelector('careiz-reward')?.readState?.()){this.complete=true;this.store('localStorage',this.completedKey,'1');this.updateTeaser();}
      },{signal:this.signal});
      if(!this.testing && document.querySelector('careiz-reward')?.readState?.()){this.complete=true;this.store('localStorage',this.completedKey,'1');}
      this.updateTeaser();
      const submittedAt=Number(this.read('sessionStorage',this.submittedKey));
      if(this.query.get('customer_posted')==='true' && submittedAt>0 && Date.now()-submittedAt<3600000){
        this.accepted();
        const clean=new URL(location.href);clean.searchParams.delete('customer_posted');
        history.replaceState(history.state,'',clean.pathname+clean.search+clean.hash);
      } else if(this.forced){
        this.open();
        const clean=new URL(location.href);clean.searchParams.delete('careiz_popup_preview');
        history.replaceState(history.state,'',clean.pathname+clean.search+clean.hash);
      } else if(!this.editor && !this.otherPreview && this.active && !this.isPolicyPage()) {
        this.touch();this.schedule();
        this.heartbeat=setInterval(()=>{if(!document.hidden)this.touch();},15000);
      }
    }
    read(area,key){try{return window[area].getItem(key);}catch{return null;}}
    store(area,key,value){try{window[area].setItem(key,value);}catch{}}
    visit(){try{return JSON.parse(this.read('localStorage',this.visitKey)) || this.memoryVisit;}catch{return this.memoryVisit;}}
    saveVisit(value){this.memoryVisit=value;this.store('localStorage',this.visitKey,JSON.stringify(value));}
    touch(){
      if(this.editor || this.otherPreview || !this.active)return;
      this.saveVisit(logic.visit(this.visit(),Date.now(),this.idleMs));
    }
    isPolicyPage(){return this.query.get('view')?.startsWith('careiz-') || location.pathname.endsWith('/careiz-welcome');}
    schedule(){
      clearTimeout(this.timer);
      if(!this.active || this.editor || this.otherPreview || this.complete || this.pending || document.hidden || this.isPolicyPage())return;
      const visit=this.visit();
      if(!visit || visit.shownAt!=null)return;
      this.timer=setTimeout(()=>this.maybeOpen(),Math.max(0,this.delayMs-(Date.now()-visit.startedAt)));
    }
    maybeOpen(){
      if(document.hidden || this.complete || this.pending)return;
      const visit=this.visit();
      if(!logic.due(visit,Date.now(),this.delayMs))return;
      if(document.querySelector('dialog[open],cart-drawer.active,details[open] > .header__menu-item') || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName)){
        this.timer=setTimeout(()=>this.maybeOpen(),1000);return;
      }
      this.saveVisit({...visit,shownAt:Date.now(),lastSeenAt:Date.now()});
      this.open();
    }
    updateTeaser(){this.teaser.hidden=!(this.dataset.teaser==='true' && (this.active || this.forced || this.editor) && !this.complete && !this.otherPreview);}
    open(){
      if(this.dialog.open)return;
      this.previousFocus=document.activeElement;this.previousOverflow=document.documentElement.style.overflow;
      this.dialog.showModal();document.documentElement.style.overflow='hidden';
      if(!this.editor && !this.otherPreview){const visit=this.visit() || logic.visit(null,Date.now(),this.idleMs);this.saveVisit({...visit,shownAt:Date.now(),lastSeenAt:Date.now()});}
    }
    close(){
      if(!this.dialog.open)return;
      this.dialog.close();this.shield.hidden=true;this.restore();
    }
    restore(){
      this.shield.hidden=true;document.documentElement.style.overflow=this.previousOverflow || '';
      if(this.previousFocus?.isConnected && !this.previousFocus.closest('dialog:not([open])'))this.previousFocus.focus();
    }
    clearError(){this.error.hidden=true;this.error.textContent='';this.email.removeAttribute('aria-invalid');this.email.removeAttribute('aria-describedby');this.error.removeAttribute('data-service');}
    accepted(){
      this.pending=false;clearTimeout(this.timeout);this.complete=true;this.store('sessionStorage',this.submittedKey,'');
      this.dialog.removeAttribute('data-pending');this.submitButton.disabled=false;this.submitButton.removeAttribute('aria-busy');this.submitButton.innerHTML=this.submitLabel;this.store('localStorage',this.completedKey,'1');
      this.form.hidden=false;this.verification.hidden=true;this.close();this.updateTeaser();
      customElements.whenDefined('careiz-reward').then(()=>document.querySelector('careiz-reward')?.registered());
    }
    fail(message,emailError=false,restoreForm=true){
      this.pending=false;clearTimeout(this.timeout);this.dialog.removeAttribute('data-pending');this.verification.hidden=true;
      this.submitButton.disabled=false;this.submitButton.removeAttribute('aria-busy');this.submitButton.innerHTML=this.submitLabel;
      this.error.textContent=message;this.error.hidden=false;
      if(emailError){this.email.setAttribute('aria-invalid','true');this.email.setAttribute('aria-describedby',this.error.id);}
      if(restoreForm){this.form.hidden=false;if(!this.dialog.open)this.open();}
    }
    submit(event){
      if(this.pending){event.preventDefault();return;}
      this.clearError();this.email.value=this.email.value.trim();
      if(!logic.email(this.email.value)){event.preventDefault();this.fail(this.email.dataset.validation,true);this.email.focus();return;}
      if(!this.form.reportValidity()){event.preventDefault();return;}
      if(this.dataset.thanksMode==='page'){
        this.form.target='_self';
        this.store('sessionStorage','careiz-popup-submitted-v1','1');
        return;
      }
      const rewardCode=document.querySelector('careiz-reward')?.dataset.code;
      if(rewardCode){const tags=this.form.querySelector('[name="contact[tags]"]');tags.value=tags.value.split(',').filter(tag=>!tag.startsWith('careiz-offer-')).concat('careiz-offer-'+rewardCode.toLowerCase().replace(/[^a-z0-9-]/g,'-')).join(',');}
      event.preventDefault();
      // A retry must persist the currently entered email, not reuse an older form snapshot.
      this.form.querySelector('[name="form_key"]')?.remove();
      this.pending=true;this.sending=false;this.complete=false;this.verification.hidden=false;
      this.dialog.setAttribute('data-pending','true');this.submitButton.disabled=true;this.submitButton.setAttribute('aria-busy','true');this.submitButton.innerHTML=this.submitButton.dataset.busy;
      this.request=new AbortController();
      setTimeout(()=>this.send(),0);
    }
    async send(){
      if(!this.pending || this.sending || this.request.signal.aborted)return;
      this.sending=true;
      const request=this.request;
      clearTimeout(this.timeout);this.timeout=setTimeout(()=>{this.request.abort();this.fail(this.dataset.timeout);},30000);
      try{
        const data=new FormData(this.form);
        // Custom return_to drops Shopify's native customer_posted success flag.
        // Fetch follows the native redirect without navigating the shopper's page.
        data.delete('return_to');
        this.store('sessionStorage',this.submittedKey,String(Date.now()));
        const response=await fetch(this.form.action,{method:'POST',body:new URLSearchParams(data),credentials:'same-origin',headers:{Accept:'text/html'},signal:request.signal});
        const html=await response.text();
        if(!this.pending || request!==this.request || request.signal.aborted)return;
        const doc=new DOMParser().parseFromString(html,'text/html');
        const result=doc.querySelector('[data-careiz-signup-result]');
        const returnedForm=doc.querySelector('careiz-signup form');
        const nativeError=returnedForm?.querySelector('[data-form-error],.errors') || doc.querySelector('[data-careiz-signup-result="error"]');
        const nativeSuccess=returnedForm?.querySelector('[data-form-success]');
        const state=logic.result(result?.dataset.careizSignupResult,Boolean(nativeError));
        const responseUrl=new URL(response.url);
        const challenge=responseUrl.pathname.startsWith('/challenge') || Boolean(doc.querySelector('#captcha_form,form[action*="/challenge"]'));
        const posted=responseUrl.searchParams.get('customer_posted')==='true';
        if(this.dataset.draft==='true'){
          this.dataset.registrationStatus=String(response.status);
          this.dataset.registrationPath=responseUrl.pathname;
          this.dataset.registrationResult=posted && !nativeError && !challenge ? 'accepted' : state;
        }
        if(response.ok && !nativeError && !challenge && (state==='accepted' || posted || nativeSuccess)){
          this.accepted();
          return;
        }
        if(challenge){
          this.fail('Shopify מבקשת בדיקה קצרה כדי להשלים את ההרשמה.');
          this.error.setAttribute('data-service','true');
          if(responseUrl.origin===location.origin && responseUrl.pathname.startsWith('/challenge')){
            const link=document.createElement('a');link.href=responseUrl.href;link.textContent='להשלמת ההרשמה';
            link.style.cssText='display:block;margin-top:8px;text-decoration:underline;font-weight:700';
            this.error.appendChild(link);
          }
          return;
        }
        this.fail(this.dataset.error);
      }catch(error){if(this.pending && request===this.request)this.fail(error.name==='AbortError'?this.dataset.timeout:this.dataset.error);}
    }
    disconnectedCallback(){
      clearInterval(this.heartbeat);clearTimeout(this.timer);clearTimeout(this.timeout);this.controller?.abort();this.request?.abort();
      if(this.dialog?.open){this.dialog.close();this.restore();}this.initialized=false;
    }
  });
})();
